module App.HiLO.Controllers {
    'use strict';

    export class TypeOfDocumentController {

        public showOther: boolean;
        public otherDescriptionOfDeed: string;
        public descriptionOfDeed: string = 'set in declaration';
        public test: string;

        constructor()
        {
            this.test = this['ngModel'];
        }

        public handleChange()
        {
            if (this.descriptionOfDeed === 'Other') {
               
                this.showOther = true;
            }
            else
            {
                this.showOther = false;
            }
        }

     
    }

    angular
        .module('app.common.controllers')
        .controller('app.common.controllers.typeOfDocumentController', TypeOfDocumentController);
}

